import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import Icon from "../../assets/ArrowWithStem.svg"

/**
* Megamenu supporting content component.
*
* - Requires: custom content block data in drupal "Mega Menu Content"
* - Maps the block content to the props passed from node_modules/@xaviemirmon/gatsby-drupal-menus/index.js
* - An optional default block may be set if there is not a direct match on the props passed
*/

function displayMcontent(data, props) {

  // console.log(props)
  // console.log(data)
  let returnContent = []
  let returnContentDefault = []
  let mapTo = ""
  if(props.mapTo) mapTo = props.mapTo

  data.map(function(node, index) {
    let thisMapTo, defaultContent = null
    let thisTitle,
    thisDescription,
    thisLink = ""

    if(node.field_menu_item_mapping) thisMapTo = node.field_menu_item_mapping
    if(node.field_set_as_the_default) defaultContent = node.field_set_as_the_default

    if(node.info) thisTitle = (
      <div className="nav-supporting-title">{node.info}</div>
    )
    if(node.body) thisDescription = (
      <div dangerouslySetInnerHTML={{ __html: node.body.value }} />
    )
    if(node.field_link) thisLink = (
      <Link className="supporting-content-link" to={node.field_link.url}>{node.field_link.title} <Icon width="24" /></Link>
    )

    if(thisMapTo === mapTo) {
      returnContent.push(
        <div className="nav-supporting-content" key={index}>
          {thisTitle}
          {thisDescription}
          {thisLink}
        </div>
      )
    }
    else if(defaultContent === true) {
      returnContentDefault.push(
        <div className="nav-supporting-content" key={index}>
          {thisTitle}
          {thisDescription}
          {thisLink}
        </div>
      )
    }
    return true;

  })


  if(returnContent.length < 1) returnContent = returnContentDefault
  return (returnContent)

}

const Mcontent = (props) => (
  <StaticQuery

    query={graphql`
      query {
        content: allBlockContentMegaMenuContent {
          nodes {
            body {
              value
            }
            field_link {
              title
              url
            }
            field_menu_item_mapping
            field_set_as_the_default
            info
          }
        }
      }
    `}

    render={data => (
      <>
        {displayMcontent(data.content.nodes, props)}
      </>
    )}
  />

)

export default Mcontent

